import { FAQ_USER_TYPES } from "../../utils/faqRoles";

// Dev/test-only role override (work order F3): the design's role simulator
// bar is design-time only and is NOT part of the page. This internal panel is
// rendered EXCLUSIVELY in development builds so the 8 user types of the index
// matrix can be exercised without eight accounts. Production role resolution
// always comes from the real auth state.
const FaqDevRolePanel = ({ override, onOverride }) => {
  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div className="flex flex-wrap items-center gap-2 border border-dashed border-[#C8CCD3] bg-[#E4E7EB] px-3 py-2 font-faqmono text-[11px] text-[#5A626E]">
      <span className="uppercase tracking-[.1em]">dev only · viewer type</span>
      <button
        type="button"
        onClick={() => onOverride(null)}
        className={`border border-[#C8CCD3] px-2 py-1 ${!override ? "bg-[#14171C] text-white" : "bg-white"}`}
      >
        auto
      </button>
      {Object.keys(FAQ_USER_TYPES).map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => onOverride(k)}
          className={`border border-[#C8CCD3] px-2 py-1 ${override === k ? "bg-[#14171C] text-white" : "bg-white"}`}
        >
          {k}
        </button>
      ))}
    </div>
  );
};

export default FaqDevRolePanel;
